// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.winner-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(31, 27, 250, 0.103);
  margin: 20px;
  margin-top: 5px;
  border-radius: 10px;
}

.winner-modal-mr-newsie img {
  height: 110px;
  width: 110px;
}

.completed-game-final-details-container {
  width: 80%;
  justify-content: center;
  gap: 15px;
  display: flex;
  margin-top: 15px;
  margin-bottom: 10px;
}

.set-username-cta {
  background-color: rgba(139, 133, 114, 0.267);
  color: rgba(31, 27, 250, 0.726);
  border-radius: 10px;
  padding: 5px;
  padding-left: 8px;
  padding-right: 8px;
  /* border-width: 1px; */
  /* border-color: rgb(1, 85, 211); */
  /* border-style: solid; */
  font-weight: bolder;
  box-shadow: 10px 5px 5px rgba(194, 204, 241, 0.61);

  width: -moz-fit-content;

  width: fit-content;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}

.set-username-cta:hover {
  opacity: 0.8;
}

.winner-modal-header-text-container {
  margin-top: 10px;
}

.winner-modal-header-text-container h4 {
  margin: 0px;
  padding: 0px;
}

.share-button-wrapper {
  margin: 10px;
}

@keyframes jump {
  0% {
    /* opacity: 0; */
    padding-top: 10px;
    padding-bottom: 0px;
  }
  50% {
    /* opacity: 1; */
    padding-top: 0px;
    padding-bottom: 10px;
  }
  80% {
    /* opacity: 1; */
    padding-top: 10px;
    padding-bottom: 0px;
  }
  100% {
    /* opacity: 1; */
    padding-top: 10px;
    padding-bottom: 0px;
  }
}

.winner-modal-mr-newsie {
  animation: jump 1.5s linear infinite, fadeIn 3s;
}

.confetti-container {
  position: absolute;
  /* Will This work? */
  top: 25px;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/Winner/Winner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;;EAElD,uBAAkB;;EAAlB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".winner-modal {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(31, 27, 250, 0.103);\n  margin: 20px;\n  margin-top: 5px;\n  border-radius: 10px;\n}\n\n.winner-modal-mr-newsie img {\n  height: 110px;\n  width: 110px;\n}\n\n.completed-game-final-details-container {\n  width: 80%;\n  justify-content: center;\n  gap: 15px;\n  display: flex;\n  margin-top: 15px;\n  margin-bottom: 10px;\n}\n\n.set-username-cta {\n  background-color: rgba(139, 133, 114, 0.267);\n  color: rgba(31, 27, 250, 0.726);\n  border-radius: 10px;\n  padding: 5px;\n  padding-left: 8px;\n  padding-right: 8px;\n  /* border-width: 1px; */\n  /* border-color: rgb(1, 85, 211); */\n  /* border-style: solid; */\n  font-weight: bolder;\n  box-shadow: 10px 5px 5px rgba(194, 204, 241, 0.61);\n\n  width: fit-content;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.set-username-cta:hover {\n  opacity: 0.8;\n}\n\n.winner-modal-header-text-container {\n  margin-top: 10px;\n}\n\n.winner-modal-header-text-container h4 {\n  margin: 0px;\n  padding: 0px;\n}\n\n.share-button-wrapper {\n  margin: 10px;\n}\n\n@keyframes jump {\n  0% {\n    /* opacity: 0; */\n    padding-top: 10px;\n    padding-bottom: 0px;\n  }\n  50% {\n    /* opacity: 1; */\n    padding-top: 0px;\n    padding-bottom: 10px;\n  }\n  80% {\n    /* opacity: 1; */\n    padding-top: 10px;\n    padding-bottom: 0px;\n  }\n  100% {\n    /* opacity: 1; */\n    padding-top: 10px;\n    padding-bottom: 0px;\n  }\n}\n\n.winner-modal-mr-newsie {\n  animation: jump 1.5s linear infinite, fadeIn 3s;\n}\n\n.confetti-container {\n  position: absolute;\n  /* Will This work? */\n  top: 25px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
